<template>
    <TresPoints :position="position">
        <TresBufferGeometry>
            <TresBufferAttribute
                attach="attributes-position"
                :count="particles.length / 3"
                :array="particles"
                :itemSize="3"
            />
        </TresBufferGeometry>
        <TresPointsMaterial
            :blending="AdditiveBlending"
            :size="size"
            color="#ffffff"
            :size-attenuation="true"
            :transparent="true"
            :opacity="0.9"
            :depth-write="false"
            :map="texture"
        />
    </TresPoints>
</template>

<script setup>
import { AdditiveBlending, TextureLoader } from "three";

const props = defineProps({
    position: {
        type: Array,
        default: () => [0, 0, 0],
    },
    count: {
        type: Number,
        default: 10000,
    },
    radius: {
        type: Number,
        default: 100,
    },
    size: {
        type: Number,
        default: 0.05,
    },
});
const texture = ref(null);
onMounted(() => {
    const loader = new TextureLoader();
    loader.load("/about/star.png", (loaded) => {
        texture.value = loaded;
    });
    updateParticles();
});
const particles = ref(new Float32Array(props.count * 3));

const updateParticles = () => {
    const arr = particles.value;
    for (let i = 0; i < props.count; i++) {
        const i3 = i * 3;
        const rawR = Math.pow(Math.random(), 0.3);
        const r = props.radius * rawR;

        const theta = Math.random() * Math.PI * 2;
        const phi = Math.acos(2 * Math.random() - 1);

        arr[i3] = r * Math.sin(phi) * Math.cos(theta);
        arr[i3 + 1] = r * Math.sin(phi) * Math.sin(theta);
        arr[i3 + 2] = r * Math.cos(phi);
    }
};
</script>
